import { localStorageAsync } from "#app/lib/local-storage";

const WS_STORAGE_KEY = "active_workspace_id";

export async function getStoredWorkspaceId(): Promise<string | null> {
  try {
    return await localStorageAsync.getItem(WS_STORAGE_KEY);
  } catch {
    return null;
  }
}

export async function setStoredWorkspaceId(id: string): Promise<void> {
  try {
    await localStorageAsync.setItem(WS_STORAGE_KEY, id);
  } catch {}
}

export async function clearStoredWorkspaceId(): Promise<void> {
  await localStorageAsync.removeItem(WS_STORAGE_KEY).catch(() => {});
}
